$( document ).ready(function() {

  // Store the Offet of the header
  var articleoffset = $(".soleo").offset();
  var articleoffsetbottom = articleoffset.top + $(".soleo").height() - $("#toc").outerHeight();
  
  // Bind a scroll event to the window
  $(window).scroll(function() {

    // Add the fixed class to the header when you reach its scroll position. Remove "fixed" when you leave the scroll position
    if (window.pageYOffset > articleoffset.top && window.pageYOffset < articleoffsetbottom) {
      $(".scroll-indicator").addClass("fixed");
    } else if (window.pageYOffset > articleoffsetbottom.top) {
      $(".scroll-indicator").removeClass("fixed");
    } else {
      $(".scroll-indicator").removeClass("fixed");
    }

    var windowScroll = $(this).scrollTop();
    var documentHeight = $(".soleo").outerHeight();
    var windowHeight = $(this).height();
    var scrollPercent = ((windowScroll - articleoffset.top) / (documentHeight - windowHeight)) * 100;
    $('.scroll-indicator').css('width', scrollPercent + '%');
    
    if (windowScroll > 0) {
      $('.scroll-indicator').addClass('active');
    } else {
      $('.scroll-indicator').removeClass('active');
    }
      
  });
  
});